import {Icon, IconProps} from '@chakra-ui/icon';
import React from 'react';

interface GeoIconProps {
	color?: string;
	width?: string | number;
	height?: string | number;
}

export const GeoTestIcon = (props: GeoIconProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 300 300'
			fill={props.color}
			width={props.width ?? '54px'}
			height={props.height ?? '54px'}
		>
			<title>pictoTest</title>
			<g id='pictoTest'>
				<path
					className='cls-1'
					d='M266,112.71C263.62,86.47,252.65,63.54,237.1,43,221.1,21.76,199,9.62,172.68,6.67c-11.61-1.31-23.61.53-35.4,1.38-7.24.52-14.8.77-21.54,3.1A256.23,256.23,0,0,0,81.82,25.72C64,35,51.74,49.51,44.4,68.31,35,92.52,31,117.61,34.15,143.32,39,183,59.48,211.57,97.27,226.37c15.73,6.16,32.33,8.34,49.2,8.4l0,.21c.41,0,.82.06,1.22.06h5.67c9.44-1.49,19-2.76,28.09-5.31,28.94-8.07,49.62-27.48,66.64-51.26C262.18,158.83,268.11,136.81,266,112.71Zm-29.91,57.68c-15.58,21.5-34.24,39.26-60.79,46.16-9.35,2.43-19.1,3.29-29.49,5-12.16-2.12-25.1-3.1-37.26-6.72C73.26,204.36,53.7,179.51,48.56,143.7c-3.49-24.36.33-48.2,9.42-71.15,5.84-14.77,15.49-26.21,29.25-34,16.64-9.49,33.88-17.15,53.66-16.77a83.49,83.49,0,0,0,12.61-1.06c27.23-3.75,50,6,67.91,25.44a114.88,114.88,0,0,1,30.18,67.8C253.58,134.63,248.25,153.56,236.05,170.39Z'
				/>
				<path
					className='cls-1'
					d='M193,69.78c-2.19-1.73-4.63-3-7.53-2.74a13.93,13.93,0,0,0-7.6,3.35c-3.39,2.72-5.31,6.55-7.14,10.39-3.78,8-7.68,15.84-11.59,23.73-7.34,14.82-14.6,29.68-20.83,45q-3,7.42-5.67,15c-1.87-2.84-3.82-5.62-5.75-8.39-5-7.14-10.15-14.19-14.55-21.71-1.11-1.9-2.18-3.83-3.14-5.81-.22-.46-.44-.93-.65-1.4l-.15-.34c-.33-.84-.66-1.68-1-2.54-1-3-4.18-5.23-7.38-4.19-3,1-5.25,4.19-4.19,7.38,2.62,7.91,7.18,15.07,11.81,21.94,4.91,7.3,10.17,14.36,15,21.74a85.14,85.14,0,0,1,6.24,11.05c1,2.15,3.85,3.15,6,2.87a6.07,6.07,0,0,0,5-4.3q3.78-12.15,8.4-24,1.06-2.72,2.18-5.43c.36-.88.73-1.77,1.1-2.65l0-.09.64-1.5c1.51-3.52,3.08-7,4.68-10.49,6.57-14.27,13.77-28.23,20.63-42.36q1.59-3.3,3.17-6.6a52.31,52.31,0,0,1,3-6c.09-.14.44-.62.55-.78l.41-.48c.33-.35.67-.69,1-1l.1-.09,0,0,.12-.07a5.49,5.49,0,0,0,2.81.77A6.07,6.07,0,0,0,193,78.26C195,76.1,195.66,71.85,193,69.78Z'
				/>
			</g>
		</svg>
	);
};

export const GeoScanIcon = (props: GeoIconProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 290 240'
			fill={props.color}
			width={props.width ?? '54px'}
			height={props.height ?? '54px'}
		>
			<title>pictoScans</title>
			<g id='pictoScans'>
				<path
					className='cls-1'
					d='M266,112.71C263.62,86.47,252.65,63.54,237.1,43,221.1,21.76,199,9.62,172.68,6.67c-11.61-1.31-23.61.53-35.4,1.38-7.24.52-14.8.77-21.54,3.1A256.23,256.23,0,0,0,81.82,25.72C64,35,51.74,49.51,44.4,68.31,35,92.52,31,117.61,34.15,143.32,39,183,59.48,211.57,97.27,226.37c15.73,6.16,32.33,8.34,49.2,8.4l0,.21c.41,0,.82.06,1.22.06h5.67c9.44-1.49,19-2.76,28.09-5.31,28.94-8.07,49.63-27.48,66.64-51.26C262.18,158.83,268.11,136.81,266,112.71Zm-29.91,57.68c-15.58,21.5-34.24,39.26-60.79,46.16-9.35,2.43-19.1,3.29-29.49,5-12.16-2.12-25.1-3.1-37.26-6.72C73.26,204.36,53.7,179.51,48.56,143.7c-3.49-24.36.33-48.2,9.42-71.15,5.84-14.77,15.49-26.21,29.25-34,16.64-9.49,33.88-17.15,53.66-16.77a83.49,83.49,0,0,0,12.61-1.06c27.23-3.75,50,6,67.91,25.44a114.88,114.88,0,0,1,30.18,67.8C253.58,134.63,248.25,153.56,236.05,170.39Z'
				/>
				<path
					className='cls-1'
					d='M130.68,73.2H115.24c-2.6,0-5.25-.14-7.84,0a7.31,7.31,0,0,0-6.12,3.5,24.53,24.53,0,0,0-1.74,4.24c-3.07,9-2.17,18.87-1.14,28.18a6.57,6.57,0,0,0,1.75,4.25,6.1,6.1,0,0,0,4.25,1.75c2.95-.13,6.37-2.66,6-6-.46-4.11-.9-8.23-1-12.38a52.43,52.43,0,0,1,.22-6.14c0-.19.28-1.92.09-.94s.14-.74.17-.92c.18-1,.41-2,.68-3,.05-.2.12-.4.18-.59h19.9a6,6,0,0,0,0-12Z'
				/>
				<path
					className='cls-1'
					d='M195.65,76.69a7.28,7.28,0,0,0-6.12-3.5c-2.6-.14-5.24,0-7.84,0H166.25a6,6,0,0,0,0,12h19.89c.06.19.13.39.19.59.27,1,.49,2,.68,3a5.19,5.19,0,0,1,.21,1.29c-.11-.88-.13-1,0-.3l.09.87a52.43,52.43,0,0,1,.22,6.14c-.07,4.15-.5,8.27-1,12.38-.35,3.13,3,6.14,6,6,3.55-.15,5.63-2.64,6-6,1-9.31,1.93-19.13-1.14-28.18A24.53,24.53,0,0,0,195.65,76.69Z'
				/>
				<path
					className='cls-1'
					d='M130.68,161.37h-19.9c-.06-.2-.13-.39-.18-.59-.27-1-.5-2-.68-3a4.69,4.69,0,0,1-.21-1.28c.11.87.12,1,0,.3q-.06-.43-.09-.87a52.6,52.6,0,0,1-.22-6.15c.07-4.14.5-8.27,1-12.38.34-3.13-3-6.13-6-6-3.55.16-5.63,2.65-6,6-1,9.32-1.93,19.13,1.14,28.19a24.86,24.86,0,0,0,1.74,4.24,7.28,7.28,0,0,0,6.12,3.49c2.59.14,5.24,0,7.84,0h15.44a6,6,0,0,0,0-12Z'
				/>
				<path
					className='cls-1'
					d='M196.77,133.21a6.09,6.09,0,0,0-4.24-1.76c-2.95.13-6.37,2.66-6,6,.46,4.11.89,8.24,1,12.38a54.88,54.88,0,0,1-.22,6.15c0,.18-.28,1.92-.1.93s-.13.75-.16.92c-.19,1-.41,2-.68,3-.06.2-.13.39-.19.59H166.25a6,6,0,0,0,0,12h15.44c2.6,0,5.24.13,7.84,0a7.33,7.33,0,0,0,6.12-3.49,24.86,24.86,0,0,0,1.74-4.24c3.07-9.06,2.17-18.87,1.14-28.19A6.5,6.5,0,0,0,196.77,133.21Z'
				/>
			</g>
		</svg>
	);
};

export const GeoPinIcon = (props: GeoIconProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 300 300'
			fill={props.color}
			width={props.width ?? '54px'}
			height={props.height ?? '54px'}
		>
			<title>pin</title>
			<g id='elements'>
				<path
					className='cls-1'
					d='M212.48,69.29a36.17,36.17,0,0,0-11.83-19.83c-6-5.12-13-8.61-20.31-11.37a97.06,97.06,0,0,0-24.84-5.72C140,30.86,123.38,34,110.27,42.75a52.82,52.82,0,0,0-16,16.68A56.23,56.23,0,0,0,87,80.14a75.23,75.23,0,0,0,.49,23.91,110.12,110.12,0,0,0,7.1,23.18,371.94,371.94,0,0,0,22.85,44.61A480.34,480.34,0,0,0,144.56,213l.84,1.13a5.54,5.54,0,0,0,.55.75,1.73,1.73,0,0,1,.27.4c.2.7.41,1.39.61,2.09a6.63,6.63,0,0,0,2.76,3.59l.28.11a5.48,5.48,0,0,0,4.34.49,6.52,6.52,0,0,0,.73-.29,5.37,5.37,0,0,0,2.86-2.47c7.31-13.51,15.17-26.71,22.68-40.11a378.78,378.78,0,0,0,20.76-41.92A166.8,166.8,0,0,0,213,92.71C213.84,84.93,214.14,77,212.48,69.29ZM158,44.64l-.42,0A1.94,1.94,0,0,1,158,44.64ZM102,70.56c-.09.21-.23.57-.23.55A1.78,1.78,0,0,1,102,70.56Zm-3.3,27.82c-.06-.36,0-.22,0,0Zm103-14.28c-.07,1.82-.2,3.65-.36,5.46-.08.84-.16,1.68-.25,2.52l-.15,1.26c0,.2-.05.41-.07.62l0,.27c0,.24-.1.71-.12.84l-.18,1.25c-.14.89-.29,1.79-.45,2.69q-.48,2.67-1,5.34a166.27,166.27,0,0,1-6,20.75c-1.24,3.45-2.59,6.85-4,10.24l-.07.16c-.17.39-.33.79-.5,1.18-.4.91-.8,1.82-1.21,2.73q-1.09,2.44-2.23,4.86c-3.15,6.71-6.56,13.3-10.09,19.82-7.16,13.21-14.84,26.12-22.19,39.22-.06.1-.12.2-.17.3-1.33-1.84-2.66-3.69-4-5.56q-6.89-9.81-13.27-20a471.92,471.92,0,0,1-23.32-41.6c-1.78-3.6-3.51-7.22-5.12-10.9-.19-.42-.37-.85-.56-1.27l-.27-.64c-.27-.63.13.33.16.37a21.18,21.18,0,0,1-1.22-3c-.7-1.79-1.37-3.58-2-5.4a100.53,100.53,0,0,1-3.24-11.43c-.39-1.8-.7-3.6-1-5.42a4.5,4.5,0,0,0-.08-.62c0-.42-.1-.84-.14-1.26q-.13-1.27-.21-2.55a62.9,62.9,0,0,1,.2-10.27c0-.37.08-.75.13-1.12v0c.14-.91.29-1.82.47-2.72q.51-2.52,1.23-5c.47-1.58,1-3.11,1.63-4.65l0-.08a.4.4,0,0,0,.06-.12c.17-.36.33-.72.5-1.07.37-.78.76-1.54,1.17-2.29a47,47,0,0,1,2.72-4.38c.23-.33.47-.65.71-1l0,0h0c.61-.72,1.2-1.45,1.84-2.15A45.56,45.56,0,0,1,112.52,56c.56-.49,1.14-1,1.72-1.42.1-.08.2-.17.3-.24l1.13-.81a57.51,57.51,0,0,1,9.11-5.07l.06,0L126,48q1.23-.48,2.49-.9c1.68-.56,3.39-1,5.11-1.47s3.47-.77,5.23-1l.63-.09.65-.08c1.07-.12,2.14-.22,3.22-.29a76.69,76.69,0,0,1,11.74.17c1,.09,2,.21,3,.33h0l.21,0,1.6.26c2,.33,3.93.74,5.87,1.2a95.41,95.41,0,0,1,11.21,3.44c.84.31,1.67.63,2.5,1l.13,0c.39.21.81.36,1.21.53,1.58.72,3.14,1.49,4.66,2.33s3,1.72,4.38,2.69c.33.23.65.45,1,.68l.38.28.56.45,1,.88A34.22,34.22,0,0,1,196.21,62v0a9.42,9.42,0,0,0,.76,1c.49.72,1,1.46,1.37,2.22a12.81,12.81,0,0,0,1.09,2.23c0,.12.09.24.14.36.16.45.32.91.47,1.38a36.93,36.93,0,0,1,1.24,5.29.68.68,0,0,1,0,.14,9.27,9.27,0,0,0,.14,1.18c.08.91.14,1.83.18,2.74C201.71,80.43,201.7,82.27,201.63,84.1Z'
				/>
				<path
					className='cls-1'
					d='M142.64,113.67l.39.18.07,0,.2.08C142.7,113.67,142.57,113.63,142.64,113.67Z'
				/>
				<path
					className='cls-1'
					d='M170.25,92.86c0-.11,0-.23,0-.34l0-.11C170.19,93.35,170.26,93.18,170.25,92.86Z'
				/>
				<path
					className='cls-1'
					d='M176.68,76.57a30.94,30.94,0,0,0-5.21-5.63,51.13,51.13,0,0,0-6.1-4.68c-5.41-3.31-12-2.49-18.1-2.46-5.32,0-11.15.39-15.63,3.6l-.11,0c-3.58,1.74-6.37,5.11-8.56,8.34a31.34,31.34,0,0,0-4.5,10.57c-2,8.6-1.14,18,3.66,25.57a28.55,28.55,0,0,0,10,9.62,34.93,34.93,0,0,0,17.45,6,31.57,31.57,0,0,0,13.07-2.7,33.8,33.8,0,0,0,12.05-7.78c7-7.45,8.71-17.81,7.15-27.63A30.16,30.16,0,0,0,176.68,76.57Zm-18-.35s-.12,0-.26-.12C158.59,76.15,158.71,76.19,158.72,76.22Zm-1.39-.42a1.16,1.16,0,0,1-.31,0A1,1,0,0,1,157.33,75.8ZM169,104.3a4.09,4.09,0,0,1,.18-.43A1.33,1.33,0,0,1,169,104.3Zm1.37-5.78c0,.2,0,.41-.05.61v.08s-.16,1-.19,1.12c-.08.4-.17.79-.26,1.18-.25,1-.6,1.91-.91,2.86v0a1.58,1.58,0,0,0-.09.17c-.17.36-.36.72-.55,1.06s-.46.81-.72,1.2l-.33.5s-.12.18-.23.32l0,0-.51.59-.81.84c-.33.32-.66.63-1,.93l-.44.38h0a31.78,31.78,0,0,1-4.57,2.71l-.45.21-1,.41c-.87.32-1.75.6-2.64.86s-1.78.48-2.69.67l-1,.2c-.13,0-.27,0-.41,0a20.14,20.14,0,0,1-2.69-.07l-.48-.07c-.47-.09-.94-.2-1.41-.32-.85-.21-1.68-.47-2.51-.76l-1-.37.29.14-.49-.22-.06,0a3.11,3.11,0,0,1-.4-.19,30.82,30.82,0,0,1-4.5-2.49c-.44-.25-.87-.5-1.29-.78l-.35-.23a8.82,8.82,0,0,0-1.1-.91c-.37-.33-.73-.69-1.07-1.05s-.67-.75-1-1.12l0,0-.19-.26c-.5-.73-1-1.47-1.4-2.25-.24-.44-.47-.89-.68-1.34,0-.09-.09-.18-.13-.27v0c-.34-1-.67-1.94-.92-3-.11-.44-.2-.88-.29-1.32,0-.22-.07-.44-.11-.66-.09-1.19-.17-2.37-.15-3.56q0-.9.09-1.8l.09-.89c.08-.69.07-.6,0,.25a11.55,11.55,0,0,1,.63-3.1c.3-1.17.72-2.29,1.07-3.45h0c.2-.42.41-.82.63-1.23.41-.75.85-1.48,1.33-2.2a14.59,14.59,0,0,0,.86-1.18l.26-.31a25.16,25.16,0,0,1,2-2l.17-.1.13-.08a3.77,3.77,0,0,0,.93-.49,12.6,12.6,0,0,1,1.15-.75l.4-.22-.26.06.29-.08.08,0c.31-.18.59-.17.26,0,.66-.2,1.31-.46,2-.6l.73-.13.84-.09c.93-.07,1.87-.1,2.81-.12,2.18,0,4.36,0,6.54,0,1.13,0,2.27,0,3.4,0,.47,0,.94,0,1.41,0h.18l.53.14.35.09c.4.24.82.44,1.21.68s.74.51,1.1.76l.38.29a43.68,43.68,0,0,1,4.58,4c.31.32.59.67.89,1a3.71,3.71,0,0,1,.23.32,22.06,22.06,0,0,1,1.54,2.61c.15.3.29.6.43.9s.12.31.18.47A29.9,29.9,0,0,1,169.7,90c.2.79.34,1.58.48,2.38v-.15a1.22,1.22,0,0,0,0,.26.5.5,0,0,0,0,.12,1.64,1.64,0,0,1,0,.22h0c.06.54.1,1.07.13,1.61q.06,1.32,0,2.64C170.39,97.58,170.37,98.05,170.33,98.52Z'
				/>
				<path className='cls-1' d='M139.16,76.84l0,0,.37-.11Z' />
			</g>
		</svg>
	);
};

/**
 * TODO: use it
 */
export const GeoCheckIcon = (props: GeoIconProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 300 300'
			fill={props.color}
			width={props.width ?? '24px'}
			height={props.height ?? '24px'}
		>
			<title>check</title>
			<g id='elements'>
				<path
					d='m 192.91785,50.990973 a 19.018573,19.018573 0 0 0 -13.72659,-4.980945 25.478079,25.478079 0 0 0 -13.85305,6.089861 50.781051,50.781051 0 0 0 -13.00664,18.940957 c -6.88737,14.485085 -13.99862,28.873115 -21.11984,43.241634 -13.38571,27.0152 -26.61627,54.09843 -37.939689,82.04714 q -5.49642,13.53209 -10.34097,27.30716 c -3.40468,-5.17544 -6.9653,-10.24388 -10.47737,-15.28294 -9.08607,-13.00661 -18.48359,-25.86731 -26.518818,-39.57436 -2.022259,-3.46357 -3.959559,-6.97486 -5.710427,-10.58402 q -0.614029,-1.26482 -1.198638,-2.548 l -0.257334,-0.62139 c -0.591982,-1.5369 -1.194951,-3.06278 -1.713383,-4.63056 a 10.941797,10.941797 0 1 0 -21.090806,5.83691 167.91795,167.91795 0 0 0 21.47024,39.97295 c 8.949685,13.29861 18.541666,26.15926 27.238736,39.62292 a 154.5028,154.5028 0 0 1 11.38188,20.13742 10.827454,10.827454 0 0 0 10.89581,5.22397 11.031746,11.031746 0 0 0 9.08607,-7.8312 q 6.877809,-22.14126 15.311989,-43.77657 1.94501,-4.96148 3.96912,-9.8935 0.97433,-2.42301 2.01485,-4.86442 l 0.0737,-0.14709 1.16553,-2.73185 q 4.13455,-9.62104 8.53166,-19.12553 c 11.97527,-26.00339 25.09883,-51.45228 37.59958,-77.202669 q 2.91934,-6.00233 5.78795,-12.02421 a 94.509179,94.509179 0 0 1 5.49647,-10.904955 c 0.14709,-0.257335 0.80888,-1.117751 0.97433,-1.419253 l 0.75008,-0.867716 c 0.59193,-0.643448 1.20597,-1.253791 1.85676,-1.838399 l 0.18395,-0.147109 h 0.0734 l 0.22047,-0.110224 a 9.990831,9.990831 0 0 0 5.12653,1.400856 10.934463,10.934463 0 0 0 7.73417,-18.668181 z'
					id='path921'
					style={{fill: '#00bbff', stroke: '#00bbff', strokeWidth: '19.4564px'}}
				/>
			</g>
		</svg>
	);
};

export const GeoErrorIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='45'
			height='45'
			viewBox='0 0 45 45'
		>
			<g
				id='Groupe_451'
				data-name='Groupe 451'
				transform='translate(-435 -669)'
			>
				<g
					id='Ellipse_36'
					data-name='Ellipse 36'
					transform='translate(435 669)'
					fill='#fff'
					stroke='#e32c2c'
					strokeWidth='2.5'
				>
					<circle cx='22.5' cy='22.5' r='22.5' stroke='none' />
					<circle cx='22.5' cy='22.5' r='21.25' fill='none' />
				</g>
				<path
					id='Tracé_247'
					data-name='Tracé 247'
					d='M-1249.137,4239.262v24'
					transform='translate(4346.869 -1431.323) rotate(45)'
					fill='none'
					stroke='#e32c2c'
					strokeLinecap='round'
					strokeWidth='2.5'
				/>
				<path
					id='Tracé_248'
					data-name='Tracé 248'
					d='M-1235.356,4254.375h24'
					transform='translate(4330.84 -1451.754) rotate(45)'
					fill='none'
					stroke='#e32c2c'
					strokeLinecap='round'
					strokeWidth='2.5'
				/>
			</g>
		</svg>
	);
};

export const GeoCreditActive = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300' fill='black'>
			<title>pictoCredits-active</title>
			<g id='pictoCredits'>
				{/* <defs><style>.cls-1{fill:#d4f3fc;}.cls-2{fill:#0bf;}.cls-3{fill:#3c3732;}</style></defs> */}
				<path
					className='cls-1'
					fill='#d4f3fc'
					d='M145.61,224.73c10.7-1.76,20.74-2.65,30.36-5.15,27.34-7.11,46.56-25.39,62.6-47.53,12.56-17.34,18.05-36.83,16-58.16a118.22,118.22,0,0,0-31.07-69.81c-18.4-20-41.88-30.06-69.92-26.2a84.75,84.75,0,0,1-13,1.09c-20.37-.39-38.12,7.5-55.26,17.27C71.15,44.31,61.22,56.09,55.2,71.3c-9.35,23.63-13.29,48.18-9.69,73.26,5.29,36.88,25.43,62.47,61.73,73.26C119.76,221.55,133.08,222.56,145.61,224.73Z'
				/>
				<path
					className='cls-2'
					fill='#0bf'
					d='M187.47,136.9a17.13,17.13,0,0,0-2.25-5.56,46.54,46.54,0,0,0-4.51-6.56,24.36,24.36,0,0,0-13.84-8.23c-4.48-.94-9-1-13.57-1.5a25.52,25.52,0,0,1-4-1c-.42-.22-.84-.46-1.25-.72a15.23,15.23,0,0,1-1.2-1.21,16,16,0,0,1-.93-1.61,22,22,0,0,1-.81-3,26.57,26.57,0,0,1,0-4.37,27.18,27.18,0,0,1,1.21-4.41,22.37,22.37,0,0,1,1.35-2.38c.2-.23.42-.45.64-.67.38-.11.76-.2,1.14-.28a48.28,48.28,0,0,1,9.15.32A64.3,64.3,0,0,1,174,100.05l-.33-.14a9.06,9.06,0,0,0,6,.5,9,9,0,0,0,6.29-11.07c-.68-2.08-2-4.46-4.14-5.38a78,78,0,0,0-19-5.69q.33-7.14,0-14.28a9.44,9.44,0,0,0-2.64-6.36,9,9,0,0,0-12.73,0A9,9,0,0,0,144.69,64c.24,4.67.24,9.34,0,14a18.7,18.7,0,0,0-1.85.52,21.12,21.12,0,0,0-11.58,10.08,34,34,0,0,0-4.12,19.93A31.15,31.15,0,0,0,130.53,120a24.91,24.91,0,0,0,7.82,8.54c6.53,4.65,14.74,4.36,22.37,5.17a26.47,26.47,0,0,1,3.84.91,15.86,15.86,0,0,1,1.54.9,21,21,0,0,1,1.46,1.52,34.11,34.11,0,0,1,2.35,3.71s0,.1,0,.16a27.76,27.76,0,0,1,0,3.87c-.34.53-.72,1-1.11,1.57a50.69,50.69,0,0,1-7.84,8.13,35.64,35.64,0,0,1-5.65,3.33,30.49,30.49,0,0,1-4.78,1.32,27.53,27.53,0,0,1-4.63,0,29.26,29.26,0,0,1-4.93-1.35,29.06,29.06,0,0,1-4-2.3,26.78,26.78,0,0,1-3.36-3.29,9,9,0,0,0-15.37,6.37,10.08,10.08,0,0,0,2.64,6.36c6.13,7.23,15.16,11.2,24.44,12.17v10a9.27,9.27,0,0,0,2.63,6.36A9,9,0,0,0,163.42,187V173.88a39.71,39.71,0,0,0,7.17-4.22,55.94,55.94,0,0,0,9.82-9.13c1.59-1.93,3.12-3.92,4.53-6a13.59,13.59,0,0,0,2.47-5.22A35.73,35.73,0,0,0,187.47,136.9Zm-18.66,9.49c-.45.59-.91,1.16-1.33,1.72Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M266,112.71C263.62,86.47,252.65,63.54,237.1,43,221.1,21.76,199,9.62,172.68,6.67c-11.61-1.31-23.61.53-35.4,1.38-7.24.52-14.8.77-21.54,3.1A256.23,256.23,0,0,0,81.82,25.72C64,35,51.74,49.51,44.4,68.31,35,92.52,31,117.61,34.15,143.32,39,183,59.48,211.57,97.27,226.37c15.73,6.16,32.33,8.34,49.2,8.4l0,.21c.41,0,.82.06,1.22.06h5.67c9.44-1.49,19-2.76,28.09-5.31,28.94-8.07,49.63-27.48,66.64-51.26C262.18,158.83,268.11,136.81,266,112.71Zm-29.91,57.68c-15.58,21.5-34.24,39.26-60.79,46.16-9.35,2.43-19.1,3.29-29.49,5-12.16-2.12-25.1-3.1-37.26-6.72C73.26,204.36,53.7,179.51,48.56,143.7c-3.49-24.36.33-48.2,9.42-71.15,5.84-14.77,15.49-26.21,29.25-34,16.64-9.49,33.88-17.15,53.66-16.77a83.49,83.49,0,0,0,12.61-1.06c27.23-3.75,50,6,67.91,25.44a114.88,114.88,0,0,1,30.18,67.8C253.58,134.63,248.25,153.56,236.05,170.39Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M137.25,108.93c.18.31.29.38-.21-.47l0,.08Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M138.45,111c.34.4.74.73,0,0Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M155.76,127.81c-.49-.08-1.43,0,0,0Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M136.14,99.61c0,.56,0,1.22,0,0Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M166.87,142.7c0,.12-.08.26-.12.43v0c0-.11.07-.22.1-.33S166.86,142.74,166.87,142.7Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M147.17,115c-1.37-.43-.54-.06,0,0Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M179,138.82a18,18,0,0,0-2.18-8.61,31.39,31.39,0,0,0-6.74-8.89,22.72,22.72,0,0,0-10.38-4.95,90.64,90.64,0,0,0-10.26-1.12q-1.14-.09-2.28-.21h0l.09,0a10.06,10.06,0,0,0-1.12-.18c-.73-.12-1.46-.28-2.18-.47l-1.07-.31-.39-.14a15.76,15.76,0,0,0-1.79-.9q-.32-.19-.63-.42c-.43-.39-.86-.78-1.26-1.21-.2-.23-.38-.5-.59-.7l.22.21a2,2,0,0,1-.19-.24,15.79,15.79,0,0,1-.92-1.6s-.06-.12-.09-.18a3.35,3.35,0,0,1-.18-.38h0l-.14-.27.11.19a20.62,20.62,0,0,1-.91-3.45v.18c0-.08,0-.18,0-.27a.06.06,0,0,1,0,0,2.18,2.18,0,0,1,0-.44,1.49,1.49,0,0,1,0-.21c0-.65-.07-1.31-.07-2s0-1.31.08-2c0-.32.09-.66.1-1a2.62,2.62,0,0,1,0,.29c0-.12,0-.23,0-.32a26.07,26.07,0,0,1,1.21-4.36l-.1.17a2.24,2.24,0,0,0,.13-.27c.05-.12.12-.25.18-.37s.18-.4.28-.59c.42-.84.92-1.61,1.41-2.4l0,0h0l1.1-1.12h0c.12-.07.3-.21.49-.34l.75-.24.84-.2c.67-.11.56-.11-.31,0a11,11,0,0,1,3-.16,59.91,59.91,0,0,1,6.43.28l1.38.14.22,0,.46.07c1.07.16,2.12.35,3.17.57a63.54,63.54,0,0,1,6.24,1.63c1,.32,2,.67,3,1,.44.16.87.33,1.29.5l.41.16.28.13a6.56,6.56,0,0,0,4.62.6,6.1,6.1,0,0,0,3.59-2.76c1.37-2.6.92-6.86-2.15-8.21a73,73,0,0,0-20.68-5.71A143.52,143.52,0,0,0,153.69,61c-.16-3.13-2.65-6.15-6-6-3.12.14-6.18,2.64-6,6a144.84,144.84,0,0,1-.12,16.54,19.31,19.31,0,0,0-3.49.73,17.94,17.94,0,0,0-10,8.5c-6,10.51-6.05,26.7,4.07,34.84a23.29,23.29,0,0,0,10.07,4.73,86.2,86.2,0,0,0,10.28,1.15c.76,0,1.52.12,2.28.2.36,0,.76.13,1.12.13h-.11c.73.12,1.45.27,2.17.46s1.5.61,2.22.74l.1.05,1,.54c.22.14.43.29.64.44l0,0c.57.56,1.16,1.1,1.68,1.7l.26.31c.41.5.34.41-.19-.26.34.19.71,1,.93,1.32.81,1.23,1.45,2.56,2.22,3.8a2.1,2.1,0,0,1,.06.24c0,.11,0,.24.06.36s0,.08,0,.12a28.33,28.33,0,0,1,.06,3.57c0,.36,0,.72-.07,1.08,0-.1,0-.18.07-.29,0,.14-.06.28-.08.43a.66.66,0,0,1,0,.14c.23-.59.46-.64,0,0l0,.05v0c0,.37-.17.72-.16.55a.83.83,0,0,0,0,.15c0-.07,0-.12,0-.18a3.45,3.45,0,0,1,.08-.42c-.4.58-.77,1.17-1.17,1.74-.14.21-1.17,1.9-1.36,1.87l.47-.6-.48.6c-.32.4-.65.8-1,1.19a68.7,68.7,0,0,1-6,5.92,4,4,0,0,1-.45.41l-.12.11a.5.5,0,0,1,.11-.1l-.11.08c-.41.3-.82.59-1.24.87-.73.49-1.48.95-2.25,1.39s-1.54.83-2.34,1.2h0a6.72,6.72,0,0,0-1.35.52q-1.25.43-2.52.75-.56.14-1.11.24l-.52.1c-.78,0-1.61.17-2.39.19s-1.51,0-2.26,0c-.38,0-.75-.06-1.13-.09h0l-.27-.05q-1.31-.22-2.58-.57c-.85-.23-1.69-.5-2.51-.81h0a6,6,0,0,0-1.32-.6c-.79-.4-1.56-.83-2.3-1.3l-1-.62-.33-.23a6.64,6.64,0,0,0-.84-.67q-.57-.5-1.11-1c-.63-.62-1.23-1.27-1.8-1.94-2-2.4-6.41-2.25-8.48,0a6.16,6.16,0,0,0,0,8.49A33,33,0,0,0,135,170.37a34,34,0,0,0,7.39.75V184a6,6,0,0,0,12,0V168.8c.73-.27,1.46-.57,2.18-.89A44.54,44.54,0,0,0,172,155.7c1.24-1.47,2.42-3,3.54-4.57a17.49,17.49,0,0,0,2.7-4.63A23.06,23.06,0,0,0,179,138.82ZM141,89.94a1,1,0,0,1,.55-.24Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M166.88,142.63v.07a.3.3,0,0,1,0-.1Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M136.13,105c0-1.1-.08-.94-.07-.57,0,.16,0,.32.05.48A.29.29,0,0,0,136.13,105Z'
				/>
				<path className='cls-3' fill='#3c3732' d='M166.91,142.59h0v0Z' />
				<path
					className='cls-3'
					fill='#3c3732'
					d='M166.92,142.44c0-.05,0-.1,0-.14,0,.16-.08.3-.1.41a.35.35,0,0,0,0-.08A1.62,1.62,0,0,0,166.92,142.44Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M137.41,94.87a.14.14,0,0,0,0,.06c.48-.86.38-.77.21-.47,0,.13-.12.25-.18.37S137.41,94.86,137.41,94.87Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M157.28,153.43c-.06,0-.21.18-.46.42h0Z'
				/>
			</g>
		</svg>
	);
};

export const CircleIcon = (props: IconProps) => (
	<Icon viewBox='0 0 200 200' {...props}>
		<path
			fill='currentColor'
			stroke={(props.borderColor as string) ?? 'black'}
			strokeWidth='5%'
			strokeLinecap='round'
			d='M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0'
		/>
	</Icon>
);

export const GeoScanActive = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300'>
			<title>pictoScans-active</title>
			{/* <defs><style>.cls-1{fill:#d4f3fc;}.cls-2{fill:#0bf;}.cls-3{fill:#3c3732;}</style></defs> */}
			<g id='pictoScans'>
				<path
					className='cls-1'
					fill='#d4f3fc'
					d='M145.61,224.73c10.7-1.76,20.74-2.65,30.36-5.15,27.34-7.11,46.56-25.39,62.6-47.53,12.56-17.34,18.05-36.83,16-58.16a118.22,118.22,0,0,0-31.07-69.81c-18.4-20-41.88-30.06-69.92-26.2a84.75,84.75,0,0,1-13,1.09c-20.37-.39-38.12,7.5-55.26,17.27C71.15,44.31,61.22,56.09,55.2,71.3c-9.35,23.63-13.29,48.18-9.69,73.26,5.29,36.88,25.43,62.47,61.73,73.26C119.76,221.55,133.08,222.56,145.61,224.73Z'
				/>
				<path
					className='cls-2'
					fill='#0bf'
					d='M138.68,73.2H123.24c-2.61,0-5.24-.11-7.84,0-3.46.16-7,1.82-8.72,5a32.06,32.06,0,0,0-2,5c-3.16,9.31-2.31,19.4-1.25,29,.27,2.46.82,4.55,2.63,6.37a9.16,9.16,0,0,0,6.37,2.63,9,9,0,0,0,6.36-2.63c1.51-1.65,2.89-4,2.64-6.37-.7-6.28-1.33-12.62-.68-18.93.12-.7.26-1.39.42-2.08,5.84,0,11.7.09,17.54.1,4.71,0,9.22-4.14,9-9A9.15,9.15,0,0,0,138.68,73.2Z'
				/>
				<path
					className='cls-2'
					fill='#0bf'
					d='M174.25,91.2c5.84,0,11.69-.13,17.54-.1.16.69.3,1.38.42,2.08.65,6.31,0,12.65-.68,18.93-.24,2.15,1.18,4.91,2.64,6.37a9.14,9.14,0,0,0,6.36,2.63,9,9,0,0,0,6.36-2.63,10.36,10.36,0,0,0,2.64-6.37c1.06-9.58,1.91-19.67-1.25-29a32.11,32.11,0,0,0-2-5c-1.71-3.17-5.24-4.82-8.71-5-2.6-.11-5.23,0-7.84,0H174.25c-4.71,0-9.22,4.13-9,9A9.16,9.16,0,0,0,174.25,91.2Z'
				/>
				<path
					className='cls-2'
					fill='#0bf'
					d='M138.68,161.37c-5.84,0-11.7.13-17.54.09-.16-.69-.3-1.38-.42-2.08-.65-6.3,0-12.65.68-18.93.23-2.14-1.18-4.9-2.64-6.36a9,9,0,0,0-12.73,0,10.32,10.32,0,0,0-2.63,6.36c-1.06,9.58-1.91,19.67,1.25,29a32.06,32.06,0,0,0,2,5,10.25,10.25,0,0,0,8.72,5c2.6.12,5.23,0,7.84,0h15.44c4.71,0,9.22-4.14,9-9A9.15,9.15,0,0,0,138.68,161.37Z'
				/>
				<path
					className='cls-2'
					fill='#0bf'
					d='M209.53,140.45c-.27-2.46-.82-4.55-2.64-6.36a9,9,0,0,0-12.72,0c-1.52,1.64-2.9,4-2.64,6.36.7,6.28,1.33,12.63.68,18.93-.12.7-.26,1.39-.42,2.08-5.85,0-11.7-.09-17.54-.09-4.71,0-9.22,4.14-9,9a9.16,9.16,0,0,0,9,9h15.44c2.61,0,5.24.11,7.84,0a10.29,10.29,0,0,0,8.71-5,32.11,32.11,0,0,0,2-5C211.44,160.12,210.59,150,209.53,140.45Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M266,112.71C263.62,86.47,252.65,63.54,237.1,43,221.1,21.76,199,9.62,172.68,6.67c-11.61-1.31-23.61.53-35.4,1.38-7.24.52-14.8.77-21.54,3.1A256.23,256.23,0,0,0,81.82,25.72C64,35,51.74,49.51,44.4,68.31,35,92.52,31,117.61,34.15,143.32,39,183,59.48,211.57,97.27,226.37c15.73,6.16,32.33,8.34,49.2,8.4l0,.21c.41,0,.82.06,1.22.06h5.67c9.44-1.49,19-2.76,28.09-5.31,28.94-8.07,49.63-27.48,66.64-51.26C262.18,158.83,268.11,136.81,266,112.71Zm-29.91,57.68c-15.58,21.5-34.24,39.26-60.79,46.16-9.35,2.43-19.1,3.29-29.49,5-12.16-2.12-25.1-3.1-37.26-6.72C73.26,204.36,53.7,179.51,48.56,143.7c-3.49-24.36.33-48.2,9.42-71.15,5.84-14.77,15.49-26.21,29.25-34,16.64-9.49,33.88-17.15,53.66-16.77a83.49,83.49,0,0,0,12.61-1.06c27.23-3.75,50,6,67.91,25.44a114.88,114.88,0,0,1,30.18,67.8C253.58,134.63,248.25,153.56,236.05,170.39Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M130.68,73.2H115.24c-2.6,0-5.25-.14-7.84,0a7.31,7.31,0,0,0-6.12,3.5,24.53,24.53,0,0,0-1.74,4.24c-3.07,9-2.17,18.87-1.14,28.18a6.57,6.57,0,0,0,1.75,4.25,6.1,6.1,0,0,0,4.25,1.75c2.95-.13,6.37-2.66,6-6-.46-4.11-.9-8.23-1-12.38a52.43,52.43,0,0,1,.22-6.14c0-.19.28-1.92.09-.94s.14-.74.17-.92c.18-1,.41-2,.68-3,.05-.2.12-.4.18-.59h19.9a6,6,0,0,0,0-12Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M166.25,85.2h19.89c.06.19.13.39.19.59.27,1,.49,2,.68,3a5.19,5.19,0,0,1,.21,1.29c-.11-.88-.13-1,0-.3l.09.87a52.43,52.43,0,0,1,.22,6.14c-.07,4.15-.5,8.27-1,12.38-.35,3.13,3,6.14,6,6,3.55-.15,5.63-2.64,6-6,1-9.31,1.93-19.13-1.14-28.18a24.53,24.53,0,0,0-1.74-4.24,7.28,7.28,0,0,0-6.12-3.5c-2.6-.14-5.24,0-7.84,0H166.25a6,6,0,0,0,0,12Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M130.68,161.37h-19.9c-.06-.2-.13-.39-.18-.59-.27-1-.5-2-.68-3a4.69,4.69,0,0,1-.21-1.28c.11.87.12,1,0,.3q-.06-.43-.09-.87a52.6,52.6,0,0,1-.22-6.15c.07-4.14.5-8.27,1-12.38.34-3.13-3-6.13-6-6-3.55.16-5.63,2.65-6,6-1,9.32-1.93,19.13,1.14,28.19a24.86,24.86,0,0,0,1.74,4.24,7.28,7.28,0,0,0,6.12,3.49c2.59.14,5.24,0,7.84,0h15.44a6,6,0,0,0,0-12Z'
				/>
				<path
					className='cls-3'
					fill='#3c3732'
					d='M196.77,133.21a6.09,6.09,0,0,0-4.24-1.76c-2.95.13-6.37,2.66-6,6,.46,4.11.89,8.24,1,12.38a54.88,54.88,0,0,1-.22,6.15c0,.18-.28,1.92-.1.93s-.13.75-.16.92c-.19,1-.41,2-.68,3-.06.2-.13.39-.19.59H166.25a6,6,0,0,0,0,12h15.44c2.6,0,5.24.13,7.84,0a7.33,7.33,0,0,0,6.12-3.49,24.86,24.86,0,0,0,1.74-4.24c3.07-9.06,2.17-18.87,1.14-28.19A6.5,6.5,0,0,0,196.77,133.21Z'
				/>
			</g>
		</svg>
	);
};
